import {contactApiHostName} from "../../endpoint";
import {defaultHeaders} from "../../headers";

export const accept = async (tokenModel) => {
  try {
    const result = await fetch(
      `${contactApiHostName}/business/accept-invitation-contact`,
      {
        method: "PUT",
        headers: {
          ...defaultHeaders,
        },
        body: JSON.stringify(tokenModel),
      }
    );
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
